import { render, staticRenderFns } from "./productUpload.vue?vue&type=template&id=c04455e6&scoped=true"
import script from "./productUpload.vue?vue&type=script&lang=js"
export * from "./productUpload.vue?vue&type=script&lang=js"
import style0 from "./productUpload.vue?vue&type=style&index=0&id=c04455e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04455e6",
  null
  
)

export default component.exports